module.exports = __webpack_public_path__ + "img/office-bag.f54262a1.svg";